module.exports = __webpack_public_path__ + "static/media/07_3.652e73a9.png";